import type { ConsultarOrigemInput } from '../../types/origemPedidoTypes';

export const chaveConsultaOrigem = (consulta: ConsultarOrigemInput): string =>
  JSON.stringify([
    consulta.processoId,
    consulta.perfil ?? 'SECRETARIA',
    consulta.origem.tipo,
    consulta.origem.id,
    consulta.page,
  ]);
